"use client";

import { RouteErrorView } from "@/components/error/route-error-view";

export default function WebsiteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-dvh bg-background">
      <RouteErrorView
        error={error}
        reset={reset}
        variant="card"
        navigation={{ label: "Go to homepage", href: "/" }}
        containerClassName="container mx-auto flex min-h-[70vh] items-center justify-center px-4 py-12"
      />
    </div>
  );
}
